<template>
  <div class="schedule">
    <h2>
      Schedule <br />
      Appointments
    </h2>
    <p>
      Be assured to get catered to exactly when you need it by scheduling in
      advance.
    </p>
    <div class="schedule_img">
      <img src="../assets/images/ellipse-gif.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Schedule",
};
</script>

<style lang="scss" src="../styles/schedule.scss"></style>
